import { useEffect } from 'react'
import { useRouter } from 'next/router'

const PROD_EID = '6791e220-2237-4b68-8c61-5a2c5336afad'
const UAT_EID = 'ac5074be-61cd-4c9f-9d7d-f48ddf5ac25b'

export const useMagentoStorefrontEvents = () => {
    const isUAT = Number(process.env.NEXT_PUBLIC_UAT_DEVELOP) == 1
    const router = useRouter()

    //waits for the script to load and then sets the storefront instance
    useEffect(() => {
        function handleScriptLoad() {
            if (window && window.magentoStorefrontEvents) {
                console.log(
                    '[LiveSearch] MSE SDK loaded. Initializing context...'
                )
                const mse = window.magentoStorefrontEvents

                const getPageType = () => {
                    if (router.pathname === '/search') return 'srp'
                    if (
                        router.pathname.startsWith('/producto/') ||
                        router.pathname.startsWith('/giftcard/detail/')
                    )
                        return 'pdp'
                    if (router.pathname.startsWith('/categoria/')) return 'plp'
                    if (router.pathname === '/checkout') return 'checkout'
                    return 'CMS'
                }

                mse.context.setStorefrontInstance({
                    baseCurrencyCode: 'CLP',
                    storeViewCurrencyCode: 'CLP',
                    environment: 'production',
                    environmentId: isUAT ? UAT_EID : PROD_EID,
                    storeCode: 'main_website_store',
                    storeId: 1,
                    storeName: 'Casaideas',
                    storeUrl: 'https://www.casaideas.cl',
                    storeViewCode: 'default_es',
                    storeViewId: 15,
                    storeViewName: 'pylot',
                    websiteCode: 'base',
                    websiteId: 1,
                    websiteName: 'casaideas',
                    storefrontTemplate: 'Other'
                })

                mse.context.setEventForwarding({
                    commerce: true,
                    aep: false
                })

                mse.context.setSearchExtension({ version: '2.0.0' })

                mse.context.setPage({
                    pageType: getPageType(),
                    maxXOffset: 0,
                    maxYOffset: 0,
                    minXOffset: 0,
                    minYOffset: 0,
                    ping_interval: 5,
                    pings: 1
                })

                mse.publish.pageView()
            }
        }

        // If SDK already loaded (strategy="beforeInteractive"), call directly
        if (window.magentoStorefrontEvents) {
            console.log(
                '[LiveSearch] MSE SDK already available. Updating page context...'
            )
            handleScriptLoad()
        } else {
            console.log('[LiveSearch] Waiting for MSE SDK script load...')
            const script = document.querySelector('script#mse-sdk')
            script?.addEventListener('load', handleScriptLoad)
            return () => {
                script?.removeEventListener('load', handleScriptLoad)
            }
        }
    }, [router.pathname])

    return {}
}
